module.exports = __webpack_public_path__ + "img/IMG_8981_L_Black_MockedUp.f6f1d95e.jpg";